import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import InputPassword from "components/InputPasswordCustome";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";
// import SampleLogo from "assets/images/logos/LogoZumi.png";
import Link from "@mui/material/Link";
import Navbars from "examples/Navbars";
import {
  Alert,
  Box,
  Snackbar,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import useEnterKeyEvent from "hooks/useEnterKeyEvent";
// import SampleLogo from "assets/images/logos/LogoZumi.png";
import "./Style.scss";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { login, generateCaptcha, verifyCaptcha, verify2FALogin } from "api/api_register2FA";
// import UserService from "service/UserSerivce";
import OtpInput from "react-otp-input";

function SignIn() {
  // State management
  useEffect(() => {
    // Lưu lại màu gốc để khôi phục sau nếu cần
    const wrapper = document.querySelector(".wrapper");
    const oldBg = wrapper?.getAttribute("style");

    if (wrapper) {
      wrapper.setAttribute("style", "background-color: white");
    }

    return () => {
      // Khôi phục lại khi rời trang login
      if (wrapper && oldBg !== null) {
        wrapper.setAttribute("style", oldBg);
      }
    };
  }, []);
  const [captchaInput, setCaptchaInput] = useState(""); // State to store the CAPTCHA input by user
  const [captchaUrl, setCaptchaUrl] = useState(""); // State để lưu URL CAPTCHA
  const [captchaError, setCaptchaError] = useState(null); // Lưu thông báo lỗi CAPTCHA
  const [failedAttempts, setFailedAttempts] = useState(0); // New state for failed login attempts
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState({
    password: "",
    showPassword: false,
  });
  const [isLoginFail, setIsLoginFail] = useState(false);
  const [show2FADialog, setShow2FADialog] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [twoFAError, setTwoFAError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [currentLoginData, setCurrentLoginData] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  // Fetch CAPTCHA when the component is mounted
  useEffect(() => {
    if (failedAttempts >= 5) {
      // Show CAPTCHA only after 3 failed attempts
      const fetchCaptcha = async () => {
        try {
          const captchaData = await generateCaptcha();
          console.log(captchaData); // In ra dữ liệu trả về từ API để kiểm tra
          if (captchaData.success) {
            setCaptchaUrl(captchaData.captchaUrl); // Assuming CAPTCHA response has a 'captcha' field
          } else {
            setCaptchaError("Không thể tải CAPTCHA. Vui lòng thử lại.");
          }
        } catch (err) {
          setCaptchaError("Đã xảy ra lỗi khi tải CAPTCHA. Vui lòng thử lại.");
        }
      };
      fetchCaptcha();
    }
  }, [failedAttempts]); // Re-run when failedAttempts changes

  const handleRefreshCaptcha = async () => {
    try {
      const res = await generateCaptcha();

      if (res.success) {
        setCaptchaUrl(res.captchaUrl);
        setCaptchaInput(""); // reset ô nhập nếu cần
        setCaptchaError(false); // reset lỗi nếu có
      }
      if (!res.success) {
        alert("Quá nhiều yêu cầu. Vui lòng thử lại sau ít phút.");
      }
    } catch (error) {
      if (error.response && error.response.status === 429) {
        // Kiểm tra mã lỗi 429 - Too Many Requests
        // Hiển thị thông báo cho người dùng khi vượt quá giới hạn yêu cầu
        alert("Quá nhiều yêu cầu. Vui lòng thử lại sau.");
      } else {
        // Hiển thị thông báo lỗi khác nếu có
        alert("Đã xảy ra lỗi. Vui lòng thử lại.");
      }
    }
  };

  const completeLogin = (dataReceive) => {
    // ✅ 1. Lưu thiết kế tạm vào sessionStorage TRƯỚC
    const tempDesign = localStorage.getItem("tempDesignBeforeLogin");
    if (tempDesign) {
      sessionStorage.setItem("designToPendingAfterLogin", tempDesign);
      localStorage.removeItem("tempDesignBeforeLogin");
    }

    // ✅ 2. Lưu token và user
    localStorage.setItem("token", dataReceive.token);
    localStorage.setItem("refreshToken", dataReceive.refreshToken);
    localStorage.setItem(
      "user",
      JSON.stringify({
        username: userName,
        userId: dataReceive.userId,
        fullName: dataReceive.fullName,
        email: dataReceive.email,
        phone: dataReceive.phone,
        partnerId: dataReceive.partnerId,
        role: "user",
        roleId: dataReceive.roleId,
        roleName: dataReceive.roleName,
        departmentId: dataReceive.departmentId,
        permissions: dataReceive.permissions,
        permissionCodes: dataReceive.permissionCodes,
        imgLogo: dataReceive.imgLogo,
        groupCode: dataReceive.groupCode,
        colors: dataReceive.colors,
      })
    );

    // ✅ 3. Sau cùng mới navigate
    setIsProcessing(false);
    navigate("/");
  };

  const getValidateText = (key, label) => {
    let result = "";
    if (key === "userName") {
      if (label.length === 0) {
        result = "Vui lòng nhập tên tài khoàn.";
      } else if (label.length > 50) {
        result = "Tên tài khoản không được vượt quá 50 ký tự.";
      }
    } else if (key === "password") {
      if (label.length === 0) {
        result = "Vui lòng nhập mật khẩu.";
      } else if (label.length > 50) {
        result = "Mật khẩu không được vượt quá 50 ký tự.";
      }
    }
    return result;
  };

  const handleLogin = async () => {
    setIsSubmitted(true);
    if (
      getValidateText("userName", userName) !== "" ||
      getValidateText("password", password?.password) !== ""
    )
      return;
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");

    setIsProcessing(true);
    setIsLoginFail(false);
    setTwoFAError(null);

    try {
      if (failedAttempts >= 5) {
        const isCaptchaValid = await verifyCaptcha(captchaInput);
        if (!isCaptchaValid) {
          setCaptchaError("Mã CAPTCHA không đúng. Vui lòng thử lại.");
          setIsProcessing(false);
          return;
        }
      }

      const dataReceive = await login(userName, password.password);
      if (dataReceive.status === 200) {
        if (dataReceive.twofaType === 3 || dataReceive.twofaType === 4) {
          setCurrentLoginData(dataReceive);
          setShow2FADialog(true);
          setIsProcessing(false);
          return;
        }
        // Nếu không có 2FA, đăng nhập bình thường
        completeLogin(dataReceive);
      } else {
        setIsLoginFail(true);
        setFailedAttempts((prevAttempts) => prevAttempts + 1);
        setIsProcessing(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      setIsLoginFail(true);
      setFailedAttempts((prevAttempts) => prevAttempts + 1);
      setIsProcessing(false);
    }
  };

  const handleVerify2FA = async () => {
    setIsProcessing(true);
    setTwoFAError(null);

    try {
      const isValid = await verify2FALogin(userName, otpCode);
      if (isValid) {
        setShow2FADialog(false);
        completeLogin(currentLoginData);
      } else {
        setTwoFAError("Mã xác thực không chính xác hoặc đã hết hạn.");
        setIsProcessing(false);
      }
    } catch (error) {
      console.error("2FA verification error:", error);
      setTwoFAError("Đã xảy ra lỗi khi xác thực. Vui lòng thử lại.");
      setIsProcessing(false);
    }
  };

  // Check if user is already logged in
  // useEffect(() => {
  //   if (UserService.isAdmin() && UserService.isAuthenticated()) {
  //     navigate("/Dashboard");
  //   } else if (UserService.isUser() && UserService.isAuthenticated()) {
  //     navigate("/Dashboard");
  //   }
  // }, [navigate]);

  useEnterKeyEvent(show2FADialog ? [otpCode] : [userName, password], () => {
    if (show2FADialog) {
      if (otpCode.length === 6 && !isProcessing) {
        handleVerify2FA();
      }
    } else {
      handleLogin();
    }
  });
  // Close login error notification
  const handleCloseNotifyLogin = () => setIsLoginFail(false);
  const render2FADialog = () => (
    <Dialog
      open={show2FADialog}
      onClose={() => {
        setShow2FADialog(false);
        setOtpCode("");
      }}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        whiteSpace="nowrap"
        variant="body2"
        fontSize="18px"
        fontWeight="bold"
        color="#fff"
        sx={{
          textTransform: "none",
          textAlign: "left",
          color: "white",
          backgroundColor: "var(--blue-blue-100)",
          padding: "10px 24px",
        }}
        id="customized-dialog-title"
      >
        Xác thực hai bước
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            Vui lòng nhập mã xác thực từ ứng dụng Authenticator
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 3 }}>
            <OtpInput
              value={otpCode}
              onChange={setOtpCode}
              numInputs={6}
              // eslint-disable-next-line react/self-closing-comp
              separator={<span style={{ margin: "0 6px" }}></span>}
              isInputNum
              shouldAutoFocus
              inputStyle={{
                width: "40px",
                height: "40px",
                fontSize: "1.2rem",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && otpCode.length === 6 && !isProcessing) {
                  e.preventDefault();
                  handleVerify2FA();
                }
              }}
            />

            {twoFAError && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {twoFAError}
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setShow2FADialog(false);
            setOtpCode("");
          }}
          color="primary"
          disabled={isProcessing}
        >
          Hủy
        </Button>
        <Button
          onClick={handleVerify2FA}
          color="primary"
          variant="contained"
          disabled={otpCode.length !== 6 || isProcessing}
        >
          {isProcessing ? "Đang xác thực..." : "Xác thực"}
        </Button>
      </DialogActions>
    </Dialog>
  );
  // Render login form
  const renderLoginForm = () => (
    <SuiBox className="w-100">
      <SuiBox mb={2} mt={4} textAlign="center">
        <SuiTypography
          variant="h3"
          fontWeight="bold"
          sx={{
            color: "var(--gray-100)",
            textTransform: "uppercase",
          }}
        >
          Đăng nhập
        </SuiTypography>
      </SuiBox>
      <SuiBox component="form" role="form">
        <SuiBox mb={1.75}>
          <SuiTypography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "600",
              textTransform: "none",
            }}
          >
            Email
          </SuiTypography>
          <TextField
            value={userName || ""}
            onChange={(e) => setUserName(e.target.value)}
            required
            error={isSubmitted}
            helperText={isSubmitted ? getValidateText("userName", userName) : ""}
            sx={{
              width: "100%",
              "& .MuiFilledInput-root": {
                backgroundColor: "var(--blue-gray-line) !important",
              },
              "& .MuiFilledInput-input": {
                height: "22.02px",
                width: "100% !important",
                "::placeholder": {
                  fontStyle: "italic",
                },
              },
              "& .MuiFilledInput-root:before,& .MuiFilledInput-root:after": {
                border: "none",
                content: "none",
              },
              "& label.Mui-focused": {
                color: "var(--blue-blue-100)",
              },
              "& .MuiInputLabel-root": {
                color: "#aeaeae",
              },
              // "& .Mui-focused": {
              //   borderColor: "var(--blue-blue-100) !important",
              // },
            }}
            variant="filled"
            placeholder="Nhập tên tài khoản"
          />
        </SuiBox>
        <SuiBox mb={2}>
          <SuiTypography
            sx={{
              fontSize: "16px",
              color: "var(--gray-100)",
              fontWeight: "600",
              textTransform: "none",
            }}
          >
            Mật khẩu
          </SuiTypography>
          <InputPassword
            placeholder="Nhập mật khẩu"
            value={password}
            onChange={setPassword}
            required
            error={isSubmitted}
            helperText={isSubmitted ? getValidateText("password", password?.password) : ""}
          />
        </SuiBox>
        {/* Render CAPTCHA after 3 failed attempts */}
        {failedAttempts >= 5 && (
          <div>
            {captchaUrl ? <img src={captchaUrl} alt="Captcha" /> : <p>Đang tải CAPTCHA...</p>}

            <Button
              onClick={handleRefreshCaptcha}
              variant="outlined"
              size="small"
              sx={{ mt: 1, mb: 2 }}
            >
              Tạo mã CAPTCHA mới
            </Button>

            <TextField
              placeholder="Nhập mã CAPTCHA"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              fullWidth
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "var(--blue-gray-line) !important",
                },
              }}
              error={captchaError}
              helperText={captchaError ? "Vui lòng nhập mã CAPTCHA" : ""}
            />
          </div>
        )}
        <SuiBox display="flex" justifyContent="flex-end" mb={2}>
          <SuiTypography
            component={Link}
            onClick={() => navigate("/authentication/forgot-password")}
            variant="button"
            fontWeight="regular"
            sx={{
              cursor: "pointer",
              userSelect: "none",
              color: "var(--blue-blue-100)",
              fontSize: "16px",
              textTransform: "none",
            }}
          >
            Quên mật khẩu?
          </SuiTypography>
        </SuiBox>
        <SuiBox mb={2} textAlign="center">
          <SuiButton
            size="small"
            color="var(--blue-blue-100)"
            circular
            sx={{
              width: "100% !important",
              background: "var(--blue-blue-100)",
              borderRadius: "15px",
              padding: "8px 24px",
            }}
            onClick={handleLogin}
          >
            <Typography whiteSpace="nowrap" variant="body2" color="white" fontSize="14px">
              Đăng nhập
            </Typography>
          </SuiButton>
          <SuiBox textAlign="center" mt={2}>
            <p style={{ fontSize: "14px" }}>
              Bạn chưa có tài khoản?{" "}
              <span
                role="button"
                tabIndex={0}
                onClick={() => {
                  const tempDesign = localStorage.getItem("tempDesignBeforeLogin");
                  if (tempDesign) {
                    sessionStorage.setItem("designToPendingAfterLogin", tempDesign);
                    localStorage.removeItem("tempDesignBeforeLogin");
                  }
                  navigate("/authentication/sign-up");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    const tempDesign = localStorage.getItem("tempDesignBeforeLogin");
                    if (tempDesign) {
                      sessionStorage.setItem("designToPendingAfterLogin", tempDesign);
                      localStorage.removeItem("tempDesignBeforeLogin");
                    }
                    navigate("/authentication/sign-up");
                  }
                }}
                style={{
                  color: "#1976d2",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Đăng ký
              </span>
            </p>
          </SuiBox>
        </SuiBox>
      </SuiBox>
      {isLoginFail && (
        <Snackbar open={isLoginFail} autoHideDuration={3000} onClose={handleCloseNotifyLogin}>
          <Alert severity="error" sx={{ width: "100%" }} onClose={handleCloseNotifyLogin}>
            Thông tin đăng nhập không chính xác.
          </Alert>
        </Snackbar>
      )}

      {/* Display error message if CAPTCHA fails */}
      {captchaError && (
        <Snackbar
          open={Boolean(captchaError)}
          autoHideDuration={3000}
          onClose={() => setCaptchaError(null)}
        >
          <Alert severity="error" sx={{ width: "100%" }} onClose={() => setCaptchaError(null)}>
            {captchaError}
          </Alert>
        </Snackbar>
      )}
    </SuiBox>
  );

  // Main render
  return (
    <>
      <Navbars />
      <PageLayout
        sx={{
          // height: "auto",
          backgroundColor: "#386b59 !important",
          // padding: "24px",
        }}
      >
        <SuiBox sx={{ display: "flex", justifyContent: "flex-start", backgroundColor: "#FBFBFE" }}>
          <Box component="img" sx={{ width: "160px", height: "80px" }} />
        </SuiBox>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // height: "calc(100vh - 80px)",
          }}
        >
          <Box
            sx={{ width: "550px", marginTop: "100px", boxShadow: "none" }}
            className="form-container"
          >
            {renderLoginForm()}
            {render2FADialog()}
          </Box>
        </Box>
      </PageLayout>
    </>
  );
}

export default SignIn;
